<template>
  <b-card class="shadow">
    <div class="row">
      <div class="col-12" v-if="!loadingTable">
        <div class="d-flex align-items-center justify-content-between mb-4">
          <h5 class="mb-0 text-gray-800">
            {{ $t("Todos os Atendimentos") }}
          </h5>
          <b-button-group>
            <b-button
              variant="outline-dark"
              :class="viewFilterReport === true ? 'active' : ''"
              @click="viewFilters"
            >
              <i class="fas fa-filter"></i>
              {{ $t("Filtros") }}
            </b-button>
            <b-button variant="outline-dark" @click="print()">
              <i class="fas fa-print"></i>
            </b-button>
            <b-button
              variant="outline-dark"
              @click="exportar()"
              :title="$t('Exportar')"
              v-b-tooltip.hover
            >
              <i class="fas fa-file-excel"></i>
            </b-button>
          </b-button-group>
        </div>
      </div>

      <div class="col-12" v-if="viewFilterReport">
        <!-- Filtros -->
        <form @submit.prevent="getAnalytics" ref="addItem">
          <div class="row">
            <form-select
              v-model="filtroUnidades"
              label="Filtrar por Unidade"
              grid="6"
              :itens="unidades"
              :disabled="desabledSearchUnidade"
              :loading="loadingSearchUnidade"
              @input="getTecnicos()"
              v-if="$route.name != 'meus_atendimentos'"
              :multiple="true"
            />

            <form-select
              v-model="filtroTecnicos"
              grid="6"
              label="Filtrar por Técnico Responsável"
              placeholder="Selecione uma unidade antes"
              :itens="listtecnicos"
              :disabled="loadingSearchTecnicos"
              :loading="loadingSearchTecnicos"
              v-if="$route.name != 'meus_atendimentos'"
              :multiple="true"
            />

            <form-select
              v-model="filtroTipos"
              label="Filtrar por Tipo de Atendimento"
              grid="6"
              :itens="tipos"
              :disabled="loadingSearchTipos"
              :loading="loadingSearchTipos"
              :multiple="true"
            />
            <form-select
              v-model="filtroServico"
              label="Serviço"
              grid="6"
              :itens="servicos"
              :disabled="loadingSearchTipos"
              :loading="loadingSearchTipos"
              :multiple="true"
            />

            <form-select
              v-model="filtroVulnerabilidades"
              label="Vulnerabilidades"
              :itens="vulnerabilidades"
              :disabled="loadingVulnerabilidades"
              :loading="loadingVulnerabilidades"
              :multiple="true"
              grid="6"
            />

            <form-select
              v-model="filtroTecnicosAutor"
              grid="6"
              label="Filtrar por Técnico Autor"
              placeholder="Selecione uma unidade antes"
              :itens="listtecnicos"
              :disabled="loadingSearchTecnicos"
              :loading="loadingSearchTecnicos"
              :multiple="true"
            />

            <div class="col-md-6">
              <label for="input-search">
                <b>Pesquisar por Nome de Usuário</b>
              </label>
              <b-input
                placeholder="Digite o nome Nome de Usuário e clique em Gerar Relatório"
                class="form-control search-input"
                type="text"
                v-model="search"
              />
            </div>
            <form-select
              v-model="filtroOutras"
              grid="3"
              label="Outras Opções"
              :itens="[
                { id: 1, value: 'Usuário sem NIS' },
                { id: 2, value: 'Usuário sem CPF' },
                {
                  id: 3,
                  value: 'Usuário cadastrado manualmente',
                },
                {
                  id: 4,
                  value: 'Usuário Sem Data de Nascimento',
                },
                {
                  id: 5,
                  value: 'Usuário em situação de rua',
                },
              ]"
            />
            <form-select
              v-model="filtroStatus"
              grid="3"
              label="Status"
              :itens="status"
              :loading="loadingStatus"
              :disabled="loadingStatus"
              :multiple="true"
            />

            <form-toggle
              v-model="somenteMeus"
              grid="12"
              label="Somente os meus atendimentos"
            />

            <form-toggle
              v-model="filtrarDatas"
              grid="12"
              label="Filtrar por Datas?"
            />

            <template v-if="filtrarDatas">
              <form-calendar
                v-model="data_inicio"
                grid="6"
                label="Data inicial realizado"
                :max-date="dataNow"
              />

              <form-calendar
                v-model="data_fim"
                grid="6"
                label="Data final realizado"
                :required="verificaDataInicial"
                :min-date="data_inicio"
                :max-date="dataNow"
              />

              <form-calendar
                v-model="data_inicio_at"
                grid="6"
                label="Data inicial cadastro"
                :max-date="dataNow"
              />

              <form-calendar
                v-model="data_fim_at"
                grid="6"
                label="Data final cadastro"
                :required="verificaDataInicialAt"
                :min-date="data_inicio_at"
                :max-date="dataNowAt"
              />
              <form-calendar
                v-model="demanda_reprimida_start"
                grid="6"
                label="Data inicial Demanda Reprimida"
                :max-date="dataNow"
              />

              <form-calendar
                v-model="demanda_reprimida_end"
                grid="6"
                label="Data final cadastro Demanda Reprimida"
                :required="verificaDataInicialDemanda"
                :min-date="demanda_reprimida_start"
                :max-date="dataNowAt"
              />
            </template>

            <form-toggle
              v-model="filtrarOutrosUsuarios"
              grid="12"
              label="Filtrar por outros usuários no atendimento?"
            />

            <template v-if="filtrarOutrosUsuarios">
              <div class="col-md-6">
                <label for="input-search">
                  <b>Pesquisar por nome de outros usuários</b>
                </label>
                <b-input
                  placeholder="Digite o nome Nome de Usuário e clique em Gerar Relatório"
                  class="form-control search-input"
                  type="text"
                  v-model="filtroSearchOutroUsuario"
                />
              </div>

              <form-select
                v-model="filtroParentescoUsuario"
                grid="6"
                label="Parentesco com usuário atendido"
                :itens="$root.arrays.posicao_familiar"
                :required="true"
              />
            </template>
          </div>
          <div class="row pt-4 mb-4 px-0 d-flex justify-content-end">
            <div class="col-auto px-2 text-right">
              <button
                class="btn btn-default"
                @click.prevent="limparFiltros(), (viewFilterReport = false)"
              >
                <i class="fas fa-times"></i>
              </button>

              <button
                type="button"
                class="btn btn-secondary"
                @click.prevent="limparFiltros()"
              >
                {{ $t("Limpar Filtros") }}
              </button>

              <button
                class="btn btn-success btn-submit"
                data-style="zoom-in"
                type="submit"
              >
                <i class="fas fa-chart-bar"></i>
                {{ $t("Gerar Relatório") }}
              </button>
            </div>
          </div>
        </form>
      </div>
      <loading-report
        :loading="isLoadingMsg"
        mensagem="Por favor aguarde estamos realizando sua solicitação..."
        icone="fa-smile-wink"
      ></loading-report>
      <load v-if="loadingTable" mode="table" />
      <div v-show="!loadingTable" class="col-md-12">
        <print-content>
          <template v-slot:datas>
            <p class="d-flex align-items-center justify-content-between mb-4">
              <div style="display: flex; flex-direction: row; justify-content: space-between;">
                <div style="display: flex; flex-direction: column;">
                  <span
                    >Período realizado selecionado:
                    <b>{{ datas.start }} - {{ datas.end }}</b>
                    <b-link
                      href="#"
                      @click.prevent="void 0"
                      class="mb-2"
                      variant="info"
                      v-b-popover.hover.top="
                        'Através do botão filtros você pode selecionar um intervalo de datas para impressão de seus dados.'
                      "
                    >
                      <i class="fas fa-info-circle"></i> </b-link
                  ></span>
                  <span v-if="datas_at.start_at != null && datas_at.end_at != null"
                    >Período cadastrado selecionado:
                    <b>{{ datas_at.start_at }} - {{ datas_at.end_at }}</b>
                    <b-link
                      href="#"
                      @click.prevent="void 0"
                      class="mb-2"
                      variant="info"
                      v-b-popover.hover.top="
                        'Através do botão filtros você pode selecionar um intervalo de datas para impressão de seus dados.'
                      "
                    >
                      <i class="fas fa-info-circle"></i> </b-link
                  ></span>
                  <span v-if="datas_demanda.start_demanda != null && datas_demanda.end_demanda != null"
                    >Período demanda reprimida selecionado:
                    <b>{{ datas_demanda.start_demanda }} - {{ datas_demanda.end_demanda }}</b>
                    <b-link
                      href="#"
                      @click.prevent="void 0"
                      class="mb-2"
                      variant="info"
                      v-b-popover.hover.top="
                        'Através do botão filtros você pode selecionar um intervalo de datas para impressão de seus dados.'
                      "
                    >
                      <i class="fas fa-info-circle"></i> </b-link
                  ></span>
                </div>
                <span v-if="pagination.total"
                  >Total de Registros <b>{{ pagination.total }}</b
                  >, total por página <b>{{ pagination.perPage }}</b></span
                >
                <span>
                  <a v-if="!showName" @click.prevent="mostrarNome" href="#"
                    ><i class="fas fa-eye"></i> Mostrar Nome de Registro</a
                  >
                  <a v-else @click.prevent="ocultarNome" href="#"
                    ><i class="fas fa-eye-slash"></i> Ocultar Nome de Registro</a
                  >
                </span>
            </div>
            </p>
          </template>

          <b-table
            :fields="[
              {
                key: 'protocolo',
                label: $t('Detalhes'),
              },
              {
                key: 'created_at',
                label: $t('Criado em'),
              },
              {
                key: 'status_nome',
                label: $t('Status'),
              },
              {
                key: 'actions',
                label: '',
                class: 'text-right no-print',
                thStyle: { width: '95px', minWidth: '95px' },
              },
            ]"
            :items="AtendimentosList"
            :responsive="true"
            striped
            hover
            show-empty
            small
            outlined
            stacked="xs"
            table-class="mb-3"
          >
            <template v-slot:cell(protocolo)="data">
              <i
                class="mdi mdi-lock mdi-18px text-danger"
                v-if="data.item.privado == 1"
                v-b-popover.hover.top="'Atendimento com sigilo'"
              ></i>
              Usuário(s):<br />
              <ul>
                <li v-for="pessoa in data.item.usuarios" :key="pessoa.id">
                  <b v-if="pessoa.nome_social">
                    {{ pessoa.nome_social }} ( N.R.: )
                    <span v-if="showName"> {{ pessoa.nome_completo }} </span>
                  </b>
                  <b v-else>{{ pessoa.nome_completo }}</b>
                </li>
              </ul>
              <span class="d-block" v-if="data.item.outrosUsuarios > 0">
                Outros Usuários: {{ data.item.outrosUsuarios }}
              </span>
              Protocolo: <b>{{ data.item.protocolo }}</b>
              <br />
              Tipo: <b>{{ data.item.tipo.descricao }}</b>
              <br />
              Unidade:
              <b>{{ data.item.unidade ? data.item.unidade.nome : "" }}</b>
              <br />
              Técnico responsável:
              <b>{{ data.item.tecnico.nome }}</b> -
              <span> {{ data.item.tecnico.profissao ?? "Não informado" }}</span>
              <br />
              Técnico autor:
              <b>{{ data.item.autor ? data.item.autor.nome : "Não informado" }}</b> -
              <span> {{ data.item.autor ? data.item.autor.profissao : "Não informado" }}</span>
              <br />

              <small
                class="d-block text-muted"
                v-if="data.item.outros_tecnicos.length > 0"
              >
                Outros técnicos
                <ul>
                  <li
                    v-for="tecnico in data.item.lista_outros_tecnicos"
                    :key="tecnico.nome"
                  >
                    <strong>{{ tecnico.nome | toUpper }}</strong> -
                    <span> {{ tecnico.profissao | toUpper }}</span>
                    <span class="d-block small">{{
                      tecnico.unidade.nome | toUpper
                    }}</span>
                  </li>
                </ul>
              </small>

              <small
                class="d-block text-muted"
                v-if="
                  data.item.vulnerabilidades &&
                  data.item.vulnerabilidades.length > 0
                "
              >
                Vulnerabilidades
                <ul>
                  <li
                    v-for="vulnerabilidade in data.item.vulnerabilidades"
                    :key="vulnerabilidade.id"
                  >
                    <strong>{{ vulnerabilidade.descricao | toUpper }}</strong>
                  </li>
                </ul>
              </small>
            </template>
            <template v-slot:cell(created_at)="data">
              <span class="d-block small text-small">
                Realizado:
                {{ data.item.data_cadastro | formatDate() }}
              </span>
              <span class="d-block small text-small">
                Cadastrado:
                {{ data.item.created_at | formatDate() }}
              </span>
            </template>
            <template v-slot:cell(status_nome)="data">
              <span class="small" v-html="data.item.status_nome"></span>
            </template>
            <template v-slot:cell()="data">
              <button
                @click="redirectAtendimento(data.item.id, data.item.familia_id)"
                class="px-2 mb-0 btn btn-sm btn-success"
                :title="$t('Editar')"
                v-if="
                  user_id == data.item.user_id ||
                  data.item.outros_tecnicos.indexOf(tecnico_id) != -1
                "
              >
                <i class="mdi mdi-square-edit-outline" />
              </button>
              <BotaoVisualizar
                v-if="data.item.canView"
                :to="`/dashboard/atendimentos/show/${data.item.id}`"
              />
            </template>
            <template v-slot:empty="scope">
              <div class="text-center my-5">
                <img
                  :alt="$t('No results')"
                  class="mb-5"
                  src="/img/icons/robot.svg"
                  style="max-height: 165px"
                />
                <h3 class="bold">
                  {{ $t("No records found") }}
                </h3>
              </div>
            </template>
          </b-table>
        </print-content>

        <div class="row align-items-center">
          <div class="col-lg-6 col-md-12">
            <div class="form-group d-inline-flex mb-0">
              <select
                class="form-control"
                style="width: 70px"
                v-model="perPage"
                v-on:change="getAnalytics"
              >
                <option value="5">5</option>
                <option value="10">10</option>
                <option value="25">25</option>
                <option value="50">50</option>
                <option value="100">100</option>
              </select>
            </div>
            <div class="d-inline-flex ml-2">
              <b-pagination
                :per-page="perPage"
                :total-rows="pagination.total"
                @change="changePage"
                v-model="page"
              />
            </div>
          </div>
          <div class="col-lg-6 col-md-12 mt-4 mt-lg-0">
            <div class="float-lg-right">
              {{ $t("Showing page") }}
              {{ pagination.currentPage }} {{ $t("of") }}
              {{ pagination.totalPages }}
              {{ $t("pages in") }}
              {{ pagination.total }}
              {{ $t("records") }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </b-card>
</template>

<script>
import BotaoVisualizar from '../../../../../../../resources/js/dashboard/components/widgets/BotaoVisualizar.vue';
export default {
  name: "HomeAtendimentos",
  components: { BotaoVisualizar },
  data() {
    return {
      showName: false,
      loading: true,
      loadingTable: true,
      loadingSearchUnidade: true,
      desabledSearchUnidade: true,
      loadingSearchTecnicos: true,
      loadingSearchTipos: true,
      range: "yearly",
      AtendimentosList: [],
      unidades: [],
      page: 1,
      search: null,
      perPage: 10,
      pagination: {
        currentPage: 0,
        perPage: 0,
        total: 0,
        totalPages: 0,
      },
      filtros: {
        unidade: null,
      },
      tecnicos: [],
      servicos: [],
      tipos: [],
      demanda_reprimida_start: "",
      demanda_reprimida_end: "",
      data_inicio_at: "",
      data_fim_at: "",
      verificaDataInicialAt: false,
      verificaDataInicialDemanda: false,
      isLoadingMsg: false,
      filter: false,
      user_id: null,
      tecnico_id: null,
      unidade_id: null,
      role: null,
      loadingStatus: false,
      datas: [],
      datas_at: [],
      datas_demanda: [],
      filtroOutras: [],
      filtroUnidades: [],
      filtroTecnicos: [],
      filtroStatus: [],
      filtroServico: [],
      filtroTipos: [],
      filtroDatas: [],
      filtroDatasAt: [],
      dataNowAt: moment().format("YYYY-MM-DD"),
      filtrarDatas: false,
      somenteMeus: true,
      filtroVulnerabilidades: [],
      vulnerabilidades: [],
      loadingVulnerabilidades: false,
      filtrarOutrosUsuarios: false,
      filtroSearchOutroUsuario: null,
      filtroParentescoUsuario: [],
    };
  },
  watch: {
    data_inicio_at: function (val) {
      if (val != "" && this.data_fim_at == "") {
        this.verificaDataInicialAt = true;
      } else {
        this.verificaDataInicialAt = false;
      }
    },
    demanda_reprimida_start: function (val) {
      if (val != "" && this.demanda_reprimida_end == "") {
        this.verificaDataInicialDemanda = true;
      } else {
        this.verificaDataInicialDemanda = false;
      }
    },
  },
  mounted() {
    this.getVulnerabilidades();
    this.getInformacaoCampos();
    this.getStatus();
    this.getTipos();
    this.getTecnicos();
    this.getUnidades();
    this.getAnalytics();
  },
  computed: {
    listtecnicos() {
      const pessoas = this.tecnicos;
      const map = pessoas.map((elem) => ({
        id: elem.id,
        value:
          " <b>" +
          elem.value +
          "</b> - " +
          (elem.profissao ?? "Não informado") +
          " - " +
          elem.nome_unidade,
      }));
      return map;
    },
  },
  methods: {
    mostrarNome() {
      this.showName = true;
    },
    ocultarNome() {
      this.showName = false;
    },
    filterData(value) {
      return this.$options.filters.formatDateHora(value);
    },
    changePage(page) {
      if (
        page > 0 &&
        page <= this.pagination.totalPages &&
        page !== this.page
      ) {
        this.page = page;
        this.getAnalytics();
      }
    },
    getAnalytics() {
      this.isLoadingMsg = true;
      this.loading = true;
      this.loadingTable = true;

      this.filtroDatas = [];
      this.filtroDatasDemanda = [];
      if (this.data_inicio) {
        this.filtroDatas.push(
          this.$options.filters.formatDateYMD(this.data_inicio)
        );
      }
      if (this.data_fim) {
        this.filtroDatas.push(
          this.$options.filters.formatDateYMD(this.data_fim)
        );
      }
      if (this.demanda_reprimida_start) {
        this.filtroDatasDemanda.push(
          this.$options.filters.formatDateYMD(this.demanda_reprimida_start)
        );
      }
      if (this.demanda_reprimida_end) {
        this.filtroDatasDemanda.push(
          this.$options.filters.formatDateYMD(this.demanda_reprimida_end)
        );
      }

      this.filtroDatasAt = [];
      if (this.data_inicio_at) {
        this.filtroDatasAt.push(
          this.$options.filters.formatDateYMD(this.data_inicio_at)
        );
      }
      if (this.data_fim_at) {
        this.filtroDatasAt.push(
          this.$options.filters.formatDateYMD(this.data_fim_at)
        );
      }

      axios
        .get("api/dashboard/report/atendimentos/home", {
          params: {
            page: this.page,
            search: this.search,
            perPage: this.perPage,
            pagina: this.$route.name == "meus_atendimentos" ? true : null,
            filtroUnidades: this.filtroUnidades,
            filtroTecnicos: this.filtroTecnicos,
            filtroTecnicosAutor: this.filtroTecnicosAutor,
            filtroStatus: this.filtroStatus,
            filtroTipos: this.filtroTipos,
            filtroServico: this.filtroServico,
            filtroOutras: this.filtroOutras,
            filtroDatas: this.filtroDatas,
            filtroDatasAt: this.filtroDatasAt,
            filtroDatasDemanda: this.filtroDatasDemanda,
            filtroVulnerabilidades: this.filtroVulnerabilidades,
            filtrarOutrosUsuarios: this.filtrarOutrosUsuarios ? "ok" : null,
            filtroSomenteMeus: this.somenteMeus ? "ok" : null,
            filtroSearchOutroUsuario: this.filtroSearchOutroUsuario,
            filtroParentescoUsuario: this.filtroParentescoUsuario,
          },
        })
        .then((response) => {
          this.user_id = this.$store.state.user.id;
          this.tecnico_id = this.$store.state.user.tecnico.id;
          this.unidade_id = this.$store.state.unidade;
          this.role = this.$store.state.user.role;
          this.role_name = this.$store.state.user.role_details.name;
          this.datas = response.data.datas;
          this.datas_at = response.data.datas_at;
          this.datas_demanda = response.data.datas_demanda;
          this.AtendimentosList = response.data.dados;
          this.pagination = response.data.pagination;
          if (this.pagination.totalPages < this.pagination.currentPage) {
            this.page = this.pagination.totalPages;
            this.getAnalytics();
          } else {
            this.isLoadingMsg = false;
            // this.loading = false;
          }
        })
        .finally(() => {
          setTimeout(() => {
            this.loadingTable = false;
          }, 2000);
        })
        .catch(() => {
          this.isLoadingMsg = false;
          this.loading = false;
        });
    },
    getUnidades() {
      this.loadingSearchUnidade = true;
      this.desabledSearchUnidade = true;
      axios
        .get(`api/dashboard/unidades/get/externas`)
        .then((response) => {
          this.unidades = response.data;
        })
        .finally(() => {
          this.loadingSearchUnidade = false;
          this.desabledSearchUnidade = false;
        });
    },
    getInformacaoCampos() {
      this.loading = true;
      axios
        .get(`api/dashboard/atendimento/get/imformacao/campo`)
        .then((response) => {
          this.vulnerabilidades = response.data.vunerabilidades;
          this.tipos = response.data.tipos;
          this.denuncias = response.data.denuncias;
          this.servicos = response.data.servicos;
          this.tecnicos = response.data.tecnicos;
          this.unidades = response.data.unidades_internas;
          this.outrasunidades = response.data.unidades;
          this.outrasunidades.push({
            id: 9999,
            value: "Outra",
          });
        })
        .finally(() => {
          this.loading = false;
        });
    },
    getTecnicos() {
      this.tecnicos = [];
      this.filtroTecnicos = [];
      this.loadingSearchTecnicos = true;
      axios
        .get(`api/dashboard/atendimento/tecnicos/get`, {
          params: {
            unidades: this.filtroUnidades,
          },
        })
        .then((response) => {
          this.tecnicos = response.data;
        })
        .finally(() => (this.loadingSearchTecnicos = false));
    },
    getTipos() {
      this.loadingSearchTipos = true;
      axios
        .get(`api/dashboard/report/atendimento/tipos`)
        .then((response) => {
          this.tipos = response.data;
        })
        .finally(() => (this.loadingSearchTipos = false));
    },
    getStatus() {
      this.loadingStatus = true;
      axios
        .get(`api/dashboard/report/status/atendimento`)
        .then((response) => {
          this.status = response.data;
        })
        .finally(() => {
          this.loadingStatus = false;
        });
    },
    exportar() {
      this.isLoadingMsg = true;
      this.loading = true;
      swal.fire({
        title: "Aguarde! O Arquivo está sendo gerado.",
        text: "O tempo para finalizar pode demorar dependendo a quantidade De registros.",
        imageUrl: `${window.urlbase}img/load.gif`,
        showConfirmButton: false,
      });
      axios
        .get("api/dashboard/report/atendimentos/home/export?format=csv", {
          params: {
            page: this.page,
            search: this.search,
            perPage: this.perPage,
            range: this.range,
            filtroUnidades: this.filtroUnidades,
            pagina: this.$route.name == "meus_atendimentos" ? true : null,
            filtroTecnicos: this.filtroTecnicos,
            filtroStatus: this.filtroStatus,
            filtroTipos: this.filtroTipos,
            filtroServico: this.filtroServico,
            filtroOutras: this.filtroOutras,
            filtroDatas: this.filtroDatas,
            filtroDatasAt: this.filtroDatasAt,
            filtroVulnerabilidades: this.filtroVulnerabilidades,
            export: "ok",
            filtroTecnicosAutor: this.filtroTecnicosAutor,
            filtroDatasDemanda: this.filtroDatasDemanda,
            filtrarOutrosUsuarios: this.filtrarOutrosUsuarios ? "ok" : null,
            filtroSomenteMeus: this.somenteMeus ? "ok" : null,
            filtroSearchOutroUsuario: this.filtroSearchOutroUsuario,
            filtroParentescoUsuario: this.filtroParentescoUsuario,
          },
        })
        .then((response) => {
          this.isLoadingMsg = false;
          this.loading = false;

          swal.fire({
            title: "Arquivo Pronto para Download!",
            html: `<a href="${response.data.link}" target="_blank">Clique aqui para baixar</a>`,
            icon: "success",
            showConfirmButton: false,
          });
        })
        .finally(() => {
          (this.isLoadingMsg = false), (this.loading = false);
        });
    },
    limparFiltros() {
      this.filtros = {};
      this.data_inicio = "";
      this.data_fim = "";
      this.data_inicio_at = "";
      this.data_fim_at = "";
      this.filtros.data_inicial_at = "";
      this.filtros.data_final_at = "";
      this.filtros.data_inicial = "";
      this.filtros.data_final = "";
      this.demanda_reprimida_start = "";
      this.demanda_reprimida_end = "";
      this.filtroUnidades = [];
      this.filtroTecnicos = [];
      this.filtroStatus = [];
      this.filtroTipos = [];
      this.filtroServico = [];
      this.filtroDatas = [];
      this.filtroDatasAt = [];
      this.filtroOutras = null;
      this.filtroVulnerabilidades = [];
      this.filtroSearchOutroUsuario = [];
      this.filtroTecnicosAutor = [];

      this.verificaDataInicial = false;
      this.verificaDataInicialAt = false;

      this.tecnicos = [];

      this.getAnalytics();
    },
    getOutrosTecnicos(tecnicos) {
      const todos_tecnicos = this.tecnicos;

      const localizados = [];
      todos_tecnicos.forEach((tecnico) => {
        tecnicos.forEach((value) => {
          if (value == tecnico.id) {
            localizados.push(tecnico);
          }
        });
      });

      return localizados;
    },
    redirectAtendimento(id, familia_id) {
      const url = this.$router.resolve({
        path: `/dashboard/atendimentos/edit/${id}`,
        query: { familia_id: familia_id },
      }).href;

      window.open(url, '_blank');
    },
    getVulnerabilidades() {
      this.loadingVulnerabilidades = true;
      axios
        .get(`api/dashboard/get/geral/vulnerabilidades`)
        .then((response) => {
          this.vulnerabilidades = response.data;
        })
        .finally(() => {
          this.loadingVulnerabilidades = false;
        });
    },
  },
};
</script>
